import { NgModule } from '@angular/core';
import { UserHasAnyPermissionDirective } from './directives/user-has-any-permission.directive';
import { UserHasAllPermissionsDirective } from './directives/user-has-all-permission.directive';

@NgModule({
  declarations: [
    UserHasAnyPermissionDirective,
    UserHasAllPermissionsDirective
  ],
  exports: [
    UserHasAnyPermissionDirective,
    UserHasAllPermissionsDirective
  ]
})
export class GenesysUserPermissionCheckModule {}
